import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '@environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {ActivitySearchCountResponse, ActivitySearchQuery, ActivitySearchResponse} from '@domain/activity/activity.dto';

@Injectable({
  providedIn: 'root'
})
export class ActivityPublicApi {

  protected readonly apiPrefix = 'public/activity';

  constructor(
    private readonly http: HttpClient
  ) { }

  public search(query: ActivitySearchQuery): Observable<ActivitySearchResponse> {
    return this.http.get<ActivitySearchResponse>(
      `${environment.apiUrl}/${this.apiPrefix}/search`,
      { params: this.getSearchParams(query) }
    );
  }

  public searchCount(query: ActivitySearchQuery): Observable<ActivitySearchCountResponse> {
    return this.http.get<ActivitySearchCountResponse>(
      `${environment.apiUrl}/${this.apiPrefix}/search/count`,
      { params: this.getSearchParams(query) }
    );
  }

  private getSearchParams(query: ActivitySearchQuery): HttpParams {
    const params: {[key: string]: string;} = {};
    params['town'] = query.townCode;
    if (query.daysOfWeek) {
      params['day'] = query.daysOfWeek.join(',');
    }
    if (query.dayTimes) {
      params['time'] = query.dayTimes.join(',');
    }
    if (query.level) {
      params['level'] = query.level.join(',');
    }
    if (query.gender) {
      params['gender'] = query.gender.join(',');
    }
    if (query.activityType) {
      params['activityType'] = query.activityType.join(',');
    }
    if (query.ageMin !== undefined) {
      params['ageMin'] = query.ageMin.toString();
    }
    if (query.ageMax !== undefined) {
      params['ageMax'] = query.ageMax.toString();
    }
    if (query.recurring !== undefined) {
      params['recurring'] = query.recurring.toString();
    }
    return new HttpParams({fromObject: params});
  }
}
